import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
	usePrefs,
	useLabels,
	useRequestData,
	useSitemap
} from 'wsm-common-data';
import { Tiles } from 'wsm-tiles';

import {
	inventoryCountsSelector,
	loadingInventoryCountsSelector
} from '../../server/selectors';
import { getModelLink } from '../../utils/getModelLink';
import { buildModelTileData } from '../../utils/buildModelTileData';

const TilesCarouselContainer = ({ vehicles }) => {
	const prefs = usePrefs();
	const labels = useLabels();
	const sitemap = useSitemap();
	const { locale } = useRequestData();

	const inventoryCounts = useSelector(inventoryCountsSelector);
	const loadingInventoryCounts = useSelector(loadingInventoryCountsSelector);

	const {
		modelLinkAlias,
		modelLinkParameters,
		noInventoryFallbackUrl,
		tileSize
	} = prefs;

	const modelLinkPath = `${sitemap.get(modelLinkAlias)}`;
	const hasInventoryData =
		!loadingInventoryCounts.error &&
		Object.keys(inventoryCounts).length > 0;

	// Every tile's data is computed up front, once, before the single <Tiles>
	// call below -- wsm-tiles' own layout="carousel" owns the scroll
	// container, swipe handling, and arrow buttons, so this display style
	// doesn't need its own host Slider (or a per-tile card) wrapping each entry.
	const tileData = vehicles.map((vehicle) =>
		buildModelTileData({
			vehicle,
			modelLink: getModelLink(
				modelLinkPath,
				modelLinkParameters,
				vehicle,
				noInventoryFallbackUrl,
				inventoryCounts
			),
			labels,
			locale,
			inventoryCounts,
			hasInventoryData,
			prefs
		})
	);

	return (
		<Tiles
			type="model"
			data={tileData}
			layout="carousel"
			tileSize={tileSize}
			className="pb-4"
		/>
	);
};

export default TilesCarouselContainer;

TilesCarouselContainer.propTypes = {
	vehicles: PropTypes.arrayOf(
		PropTypes.shape({
			year: PropTypes.number,
			make: PropTypes.string,
			model: PropTypes.string,
			modelInv: PropTypes.string,
			gvBodyStyle: PropTypes.string,
			image: PropTypes.string,
			inventoryCount: PropTypes.number
		})
	).isRequired
};
